import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    descriptionWrapper: {
        width: "100%",
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        color: theme.palette.info.main,
        fontWeight: 600,
    },
    text: {
        width: "100%",
    },
}));
